import { render, staticRenderFns } from "./MainLocationBlock.vue?vue&type=template&id=20cc0946&scoped=true&"
import script from "./MainLocationBlock.vue?vue&type=script&lang=js&"
export * from "./MainLocationBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainLocationBlock.vue?vue&type=style&index=0&id=20cc0946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc0946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cc0946')) {
      api.createRecord('20cc0946', component.options)
    } else {
      api.reload('20cc0946', component.options)
    }
    module.hot.accept("./MainLocationBlock.vue?vue&type=template&id=20cc0946&scoped=true&", function () {
      api.rerender('20cc0946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/MainLocationBlock.vue"
export default component.exports